<template>
  <div class="invoice-wrap-bg">
    <EditInvoiceUploadForm
      ref="uploaded-invoice-edit-form"
      emit-submit
      is-edit
      @updated="invoiceUpdated"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import EditInvoiceUploadForm from "@/components/invoices/EditInvoiceUploadForm"
export default {
  name: 'EditInvoiceUploadView',
  components: {
    EditInvoiceUploadForm,
  },
  props: {

  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      invoice: 'invoices/getInvoice'
    }),
  },
  created () {
    this.$emit('display-buttons', 'create')
  },
  methods: {
    ...mapActions ({
      loadInvoice: 'invoices/loadInvoice'
    }),
    invoiceUpdated () {
      // this.loadInvoice(this.invoice.id).then(() => {
        this.$router.push({ name: 'InvoiceView', params: { invoiceId: this.invoice.id } }).catch(() => {})
      // })
      this.$emit('invoice-updated')
    },
    saveUploadedInvoice () {
      this.$refs['uploaded-invoice-edit-form'].onSubmit()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>